export const paths = {
	userTaskManagement: `/user-task-management?from=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()}&to=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0, 0).toISOString()}`,
	index: "/",
	agents: {
		list: "/agents",
		create: "/agents/create",
	},
	clients: {
		list: "/clients",
		create: "/clients/create",
	},
	products: {
		list: "/products?tab=types",
		create: "/products/create",
	},
	reports: `/reports?reportsTab=summary&from=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()}&to=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0, 0).toISOString()}`,
	settings: "/settings",
	fixDiscounts: "/fix-discount",
	accountTransactions: `/account-transactions?accountsTab=accounts&from=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()}&to=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0, 0).toISOString()}`,
	procurementManagement: {
		suppliers: {
			list: "/procurement-management?procurementManagementTab=suppliers",
			create:
				"/procurement-management?procurementManagementTab=suppliers&action=create",
		},
		unitOfMeasurements: {
			list: "/procurement-management?procurementManagementTab=unit-of-measurements",
			create:
				"/procurement-management?procurementManagementTab=unit-of-measurements&action=create",
		},
		receivers: {
			list: "/procurement-management?procurementManagementTab=receivers",
			create:
				"/procurement-management?procurementManagementTab=receivers&action=create",
		},
		procurementItems: {
			list: "/procurement-management?procurementManagementTab=procurement-items",
			createCategory:
				"/procurement-management?procurementManagementTab=procurement-items&dataType=procurement_category&action=create",
			createItem:
				"/procurement-management?procurementManagementTab=procurement-items&dataType=procurement_item&action=create",
		},
		procurementTransactions: {
			list: `/procurement-management?procurementManagementTab=procurement-transactions&from=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()}&to=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0, 0).toISOString()}&page=1&limit=20`,
			create:
				"/procurement-management?procurementManagementTab=procurement-transactions&action=create",
		},
	},
	additionalFees: "/additional-fee",
	fileHistory: `/file-history?from=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()}&to=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0, 0).toISOString()}&page=1&limit=20`,
	fiancances: `/finances?financesTab=monthly-statement&from=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()}&to=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0, 0).toISOString()}`,
	auth: {
		login: "/login",
	},
	notAuthorized: "/401",
	notFound: "/404",
	serverError: "/500",
};
